import React from 'react';
import API from '../API';
import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import { PDV } from '../AdminClasses';

var SearchPDVModal = (props: SearchCoreProps<PDV>)=>{
	return <SearchCoreModal
		title='Buscar PDV'
		{...props}
		searchData={(query, page, page_size)=>{
			return API.searchPdv(query, page * page_size, page_size);
		}}
		pageSize={15}
		table={[
			{ name: 'ID', key: 'pdv_id', collapsing: true },
			{ name: 'Nombre', key: 'pdv_name' },
			{ name: 'Ciudad', key: 'city' },
		]}
	/>
}

export default SearchPDVModal;